// extracted by css-extract-rspack-plugin
module.exports =  {"youtube":"YouTube-S4y5__youtube","youtube--is-video-activity":"YouTube-XhC4__youtube--is-video-activity"};